var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c(
          "button",
          {
            staticClass: "btn-info",
            attrs: { type: "button" },
            on: { click: _vm.consultar }
          },
          [
            _c("i", { staticClass: "fa fa-search" }),
            _vm._v(" "),
            _c("span", [_vm._v("Consultar")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  placeholder: "Seleccione...",
                  id: "persona",
                  options: _vm.personas,
                  label: "nombre"
                },
                model: {
                  value: _vm.selectedPersona,
                  callback: function($$v) {
                    _vm.selectedPersona = $$v
                  },
                  expression: "selectedPersona"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "persona" } }, [_vm._v("Persona")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  placeholder: "Seleccione...",
                  id: "vendedor",
                  options: _vm.vendedores,
                  label: "nombre"
                },
                model: {
                  value: _vm.selectedVendedor,
                  callback: function($$v) {
                    _vm.selectedVendedor = $$v
                  },
                  expression: "selectedVendedor"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "vendedor" } }, [_vm._v("Vendedor")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "form-inline" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("label", { attrs: { for: "abiertas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "abiertas",
                value: "A"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "A") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "A")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Abiertas")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "asignadas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "asignadas",
                value: "V"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "V") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "V")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Asignadas")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "facturables" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "facturables",
                value: "B"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "B") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "B")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Facturables")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "facturadas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "facturadas",
                value: "F"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "F") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "F")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Facturadas")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "cerradas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "cerradas",
                value: "C"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "C") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "C")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Cerradas")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "anuladas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: {
                type: "radio",
                name: "estado",
                id: "anuladas",
                value: "E"
              },
              domProps: { checked: _vm._q(_vm.form.estado, "E") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "E")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Anuladas")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "todas" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.estado,
                  expression: "form.estado"
                }
              ],
              attrs: { type: "radio", name: "estado", id: "todas", value: "T" },
              domProps: { checked: _vm._q(_vm.form.estado, "T") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "estado", "T")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Todas")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "form-inline" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("label", { attrs: { for: "hoy" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipo_fecha,
                  expression: "form.tipo_fecha"
                }
              ],
              attrs: {
                type: "radio",
                name: "tipo_fecha",
                id: "hoy",
                value: "H"
              },
              domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "tipo_fecha", "H")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Hoy")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "ayer" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipo_fecha,
                  expression: "form.tipo_fecha"
                }
              ],
              attrs: {
                type: "radio",
                name: "tipo_fecha",
                id: "ayer",
                value: "A"
              },
              domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "tipo_fecha", "A")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Ayer")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "rango" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipo_fecha,
                  expression: "form.tipo_fecha"
                }
              ],
              attrs: {
                type: "radio",
                name: "tipo_fecha",
                id: "rango",
                value: "P"
              },
              domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "tipo_fecha", "P")
                  },
                  _vm.changePersonalizado
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Personalizado")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "form-field"
            },
            [
              _c(
                "div",
                { staticClass: "datepicker-field datepicker-field--stretch" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "desde",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "auto-close": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione una fecha..."
                    },
                    model: {
                      value: _vm.form.desde,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desde", $$v)
                      },
                      expression: "form.desde"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Desde")])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "form-field"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "datepicker-field datepicker-field--stretch"
                },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "hasta",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "auto-close": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione una fecha..."
                    },
                    model: {
                      value: _vm.form.hasta,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hasta", $$v)
                      },
                      expression: "form.hasta"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Hasta")])
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "form-inline" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("label", { attrs: { for: "conProforma" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.con_proforma,
                  expression: "form.con_proforma"
                }
              ],
              attrs: {
                type: "radio",
                name: "conProforma",
                id: "conProforma",
                value: "C"
              },
              domProps: { checked: _vm._q(_vm.form.con_proforma, "C") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "con_proforma", "C")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Con proforma")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "sinProforma" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.con_proforma,
                  expression: "form.con_proforma"
                }
              ],
              attrs: {
                type: "radio",
                name: "conProforma",
                id: "sinProforma",
                value: "S"
              },
              domProps: { checked: _vm._q(_vm.form.con_proforma, "S") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "con_proforma", "S")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Sin proforma")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "ambos" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.con_proforma,
                  expression: "form.con_proforma"
                }
              ],
              attrs: {
                type: "radio",
                name: "conProforma",
                id: "ambos",
                value: "A"
              },
              domProps: { checked: _vm._q(_vm.form.con_proforma, "A") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "con_proforma", "A")
                  },
                  _vm.consultar
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Ambos")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    id: "numeroProforma",
                    placeholder: "Digite un número..."
                  },
                  model: {
                    value: _vm.form.numero_proforma,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "numero_proforma", $$v)
                    },
                    expression: "form.numero_proforma"
                  }
                },
                [_c("span", [_vm._v("Número de proforma")])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    id: "numero_orden_trabajo",
                    placeholder: "Digite un número..."
                  },
                  model: {
                    value: _vm.form.numero_orden_trabajo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "numero_orden_trabajo", $$v)
                    },
                    expression: "form.numero_orden_trabajo"
                  }
                },
                [_c("span", [_vm._v("Número de orden de trabajo")])]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("k-table", {
            ref: "tablaOrdenesTrabajo",
            attrs: {
              tipoDocumento: "OT",
              filterStatus: false,
              searchEnabled: false,
              editButton: false,
              createButton: false,
              buttons: [
                {
                  text: "",
                  class: "btn-info",
                  icon: "fa-eye",
                  event: "ver"
                }
              ],
              deleteButton: false,
              path: _vm.path,
              params: _vm.form,
              columns: [
                {
                  display: "Fecha de emisión",
                  value: "fecha_emision"
                },
                {
                  display: "Número de documento",
                  value: "numero_documento"
                },
                {
                  display: "Nombre de persona",
                  value: "nombre_persona"
                },
                {
                  display: "Vendedor asignado",
                  value: "nombre_vendedor"
                },
                {
                  display: "N° Proforma",
                  value: "numero_proforma"
                },
                {
                  display: "Comentario",
                  value: "comentario"
                },
                {
                  display: "Costo total",
                  value: "costo_total",
                  numeric: true
                },
                {
                  display: "Fecha de creación",
                  value: "created_at"
                },
                {
                  display: "Estado",
                  value: "descripcion_estado"
                }
              ]
            },
            on: { ver: _vm.ver, seleccionar: _vm.seleccionar }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Órdenes de trabajo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros por estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros por fecha")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros de comprobante")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c86802e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c86802e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ordenes-trabajo/ListaOrdenesTrabajo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c86802e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ordenes-trabajo/ListaOrdenesTrabajo.vue
// module chunks = 0